import { render, staticRenderFns } from "./PieChartVolumePerNetwork.vue?vue&type=template&id=1fa70c71&scoped=true"
import script from "./PieChartVolumePerNetwork.js?vue&type=script&lang=js&external"
export * from "./PieChartVolumePerNetwork.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa70c71",
  null
  
)

export default component.exports